var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"37de16dbf1df0e7ab5eea902f0f64481811ea1a9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@kelp-dao"]={id:"37de16dbf1df0e7ab5eea902f0f64481811ea1a9"};
      